"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var warning_svg_1 = __importDefault(require("../../../res/img/warning.svg"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "input flex flex-row " + (props.className || "") },
    react_1.default.createElement("label", { htmlFor: "ti_" + props.name },
        props.altLabel || lodash_1.default.startCase(props.name.replace(/-/g, " ")),
        props.duplicate !== null && props.duplicate !== undefined ?
            react_1.default.createElement("div", { className: "duplicate-warning" },
                react_1.default.createElement("img", { src: warning_svg_1.default, alt: "Warning" }),
                react_1.default.createElement("div", { className: "text" },
                    react_1.default.createElement("p", null,
                        "A query with this reference already exists with the log number: ",
                        react_1.default.createElement("b", null, props.duplicate))))
            :
                null,
        ":"),
    react_1.default.createElement("input", __assign({}, props, { id: "ti_" + props.name, disabled: props.disabled, "data-customer": props.dataCustomer })))); });
